import { AuthController } from "../../auth/AuthController.js";
import { DashboardController } from "../../dashboard/DashboardController.js";
import { VehiclesController } from "../../vehicles/VehiclesController.js";
import { ServicesController } from "../../services/ServicesController.js";
//import { RepairsController } from "../../repairs/RepairsController.js";
import { MaintenanceController } from "../../maintenance/MaintenanceController.js";
import { ProfileController } from "../../profile/ProfileController.js";
import { QuotesController } from "../../quotes/QuotesController.js";

export class Router {
	constructor(isAuthenticated = false) {
		this.isAuthenticated = isAuthenticated;
		this.routes = {
			"": () => (this.isAuthenticated ? DashboardController.render() : AuthController.renderLogin()),
			login: () => AuthController.renderLogin(),
			register: () => AuthController.renderRegister(),
			"forgot-password": () => AuthController.renderForgotPassword(),
			"activate": () => AuthController.renderActivate(),
			"completar-perfil": () => AuthController.renderCompletarPerfil(),
			dashboard: () => this.requireAuth(() => DashboardController.render()),
			vehicles: () => this.requireAuth(() => VehiclesController.render()),
			services: () => this.requireAuth(() => ServicesController.render()),
			//repairs: () => this.requireAuth(() => RepairsController.render()),
			maintenance: () => this.requireAuth(() => MaintenanceController.render()),
			profile: () => this.requireAuth(() => ProfileController.render()),
			quotes: () => this.requireAuth(() => QuotesController.render()),
		};
	}

	init() {
		window.addEventListener("hashchange", () => this.handleRoute());
		this.handleRoute();
	}

	handleRoute() {
		const hash = window.location.hash.slice(1) || ""; // Ej: "activate?SecTkn=abc..."
		const [path, queryString] = hash.split("?");
		const route = this.routes[path] || this.routes[""];

		// Si hay parámetros, los parseamos; si no, mandamos vacío
		const params = queryString ? new URLSearchParams(queryString) : new URLSearchParams();

		// Llamar la ruta con los parámetros (si la función los acepta)
		route(params);
	}

	requireAuth(callback) {
		if (this.isAuthenticated) {
			return callback();
		} else {
			window.location.hash = "login";
			return AuthController.renderLogin();
		}
	}

	navigate(path) {
		window.location.hash = path;
	}
}
